import { ActionType } from '../types';
import { Types } from './actions';
import { INITIAL_STATE } from './constants';
import { PasswordState } from './types/PasswordState';
import { mergeReducers } from '~/store/utils';
import { get } from '~/utils/object';

const reducer = (state = INITIAL_STATE, action: ActionType): PasswordState => {
  const { type } = action;
  switch (type) {
    case Types.PASSWORD_RULES_REQUEST: {
      return {
        ...state,
        resetToken: action.payload.resetToken,
      };
    }
    case Types.PASSWORD_RULES_SUCCESS: {
      return {
        ...state,
        rules: {
          minLength: get(action.payload, 'passwordMinimumLength'),
          classCount: get(action.payload, 'passwordClassCount'),
          usePasswordStrength: get(action.payload, 'usePasswordStrength'),
        },
        error: undefined,
      };
    }

    case Types.PASSWORD_RULES_ERROR:
    case Types.PASSWORD_RULES_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

// reset password is when someone chooses a new password for themselves
const resetReducer = (
  state = INITIAL_STATE,
  action: ActionType,
): PasswordState => {
  switch (action.type) {
    case Types.SET_RESET_TOKEN: {
      return {
        ...state,
        resetToken: action.payload.resetToken,
      };
    }
    case Types.RESET_PASSWORD_REQUEST: {
      return {
        ...state,
        saved: false,
        resetIsLoading: true,
      };
    }
    case Types.RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        saved: true,
        resetToken: undefined,
        error: undefined,
        resetIsLoading: false,
      };
    }
    case Types.RESET_PASSWORD_ERROR:
    case Types.RESET_PASSWORD_FAILURE: {
      return {
        ...state,
        error: action.payload,
        resetIsLoading: false,
      };
    }
    default:
      return state;
  }
};

// forgot password is when someone requests a password reset link
const forgotPasswordReducer = (
  state = INITIAL_STATE,
  action: ActionType,
): PasswordState => {
  switch (action.type) {
    case Types.FORGOT_PASSWORD_RESET:
      return {
        ...state,
        resetLinkIsLoading: false,
        resetLinkSent: false,
        forgotPasswordMessage: null,
      };
    case Types.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        resetLinkIsLoading: true,
        resetLinkSent: false,
      };
    case Types.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        resetLinkIsLoading: false,
        resetLinkSent: true,
        forgotPasswordMessage: action.payload?.message,
      };

    case Types.FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        resetLinkIsLoading: false,
        resetLinkSent: false,
      };

    default:
      return state;
  }
};

export default mergeReducers([reducer, resetReducer, forgotPasswordReducer]);
